import clsx from 'clsx'
import React, { ReactElement } from 'react'

import s from './styles.module.scss'

import Scrollbars from '../scrollbars/scrollbars'
import { Icon } from '../../atoms'
import { cn } from '../../../shadcn/utils'

export const Container = ({
  title,
  titleClassName,
  children,
  className,
  style = {},
  isScrolling = false,
  hasCustomCollapseIcon,
  styleContent = {},
  classNameContent,
  isCollapsible,
  isOpened,
  toggleCard,
  styleTitle = {},
  onClick,
  dataTestId,
}: {
  title?: string | ReactElement
  titleClassName?: string
  children?: React.ReactNode
  className?: string
  style?: React.CSSProperties
  styleContent?: React.CSSProperties
  classNameContent?: string
  isScrolling?: boolean
  isCollapsible?: boolean
  hasCustomCollapseIcon?: boolean
  isOpened?: boolean
  toggleCard?: () => void
  styleTitle?: React.CSSProperties
  onClick?: () => void
  dataTestId?: string
}) => {
  const classNames = () => {
    let classes = s.container
    if (className) {
      classes += ` ${className}`
    }
    if (isCollapsible) {
      classes += ` ${s.collapsible}`
    }
    if (!isOpened) {
      classes += ` ${s.collapse}`
    }

    return classes
  }

  const renderContent = () => {
    return (
      <>
        {title && (
          <div
            className={cn(s.title, titleClassName)}
            style={styleTitle}
            onClick={() => toggleCard && toggleCard()}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault()
                toggleCard && toggleCard()
              }
            }}
            role='button'
            tabIndex={0}
          >
            {' '}
            {title}
            {isCollapsible && !hasCustomCollapseIcon && (
              <Icon name='arrow-down' size={12} className={s.arrowIcon} />
            )}
          </div>
        )}
        {children ? (
          <div
            className={clsx(s.content, classNameContent)}
            style={styleContent}
          >
            {children}
          </div>
        ) : null}
      </>
    )
  }

  if (isScrolling) {
    return <Scrollbars className={classNames()}>{renderContent()}</Scrollbars>
  }

  return (
    <div
      className={classNames()}
      style={style}
      onClick={onClick}
      data-testid={dataTestId}
    >
      {renderContent()}
    </div>
  )
}
